import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggleFaq = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqLd)}</script>
      <section className="w-full py-16 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              你可能想知道的一些答案
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq) => (
              <div
                key={faq.id}
                className="rounded-xl border border-background-200/70 bg-background-100/80 overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(faq.id)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${
                    openId === faq.id ? 'bg-primary-500' : 'bg-background-200'
                  }`}>
                    <i className={`text-xs transition-transform ${
                      openId === faq.id
                        ? 'ri-subtract-line text-background-50'
                        : 'ri-add-line text-foreground-600'
                    }`}></i>
                  </div>
                </button>
                {openId === faq.id && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}